// View script if needed for frontend interactivity

